import { ActivitiesMenu } from 'layouts/main/sp-header/navigation/activities-menu';
import { BlottersMenu } from 'layouts/main/sp-header/navigation/blotters-menu';
import { ExploreMenu } from 'layouts/main/sp-header/navigation/explore-menu';
import { WorkspacesMenu } from 'layouts/main/sp-header/navigation/workspaces-menu';

export function LaptopNavigation() {
  return (
    <div className="navbar-content">
      <ul className="navbar-navigation">
        <ExploreMenu />
        <WorkspacesMenu />
        <BlottersMenu />
        <ActivitiesMenu />
      </ul>
    </div>
  );
}
